<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Home',
  metaInfo: {
    title: 'Dealer Engagement Pages',
    titleTemplate: null,
  },
  created() {
    let receiverId = this.$route.query.receiver_id;
    // @TODO: remove this when mobile sends receiver id
    if (!receiverId && process.env.NODE_ENV == 'development') {
      receiverId = process.env.VUE_APP_UUID;
    }

    this.$store.dispatch('loadAppContent', {
      lead: { id: this.$route.query.lead_id, receiverId },
      engagementAction: this.$route.name,
    });
  },
};
</script>

<style>
@import '../public/css/style.css';
@import 'https://use.fontawesome.com/releases/v5.7.2/css/all.css';

/* Modal CSS-Related (Overwritting) */
#modals-container .vm--container {
  z-index: 1000;
}

/* ----------------------------------------------
 * Generated by Animista on 2021-4-5 16:46:50
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation slide-in-right
 * ----------------------------------------
 */
@-webkit-keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(1000px);
    transform: translateX(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(1000px);
    transform: translateX(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

.slide-in-right,
.slide-right-enter-active {
  /* in */
  -webkit-animation: slide-in-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  animation: slide-in-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

.slide-out-right,
.slide-right-leave-active {
  /* out */
  -webkit-animation: slide-in-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) reverse both;
  animation: slide-in-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) reverse both;
}
</style>
